export const DEFAULT_CONFIGURATION_PROFILE = {
    Account: {
        Entry0: {},
        Entry1: {},
    },
    Wan: {
        PVC11: {
            MODULE_NAME: "ProfileTemplate"
        }
    },
    Usage: {

    }
};